<template>
  <v-app-bar app v-if="$store.state.isUserLoggedIn" elevation="0">
    <v-autocomplete style="width: 235px" hide-details small v-show="!isSmallerDisplay() || minimizedDrawer" v-if="
      $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
    " :search-input="quickSearchQuery" @update:search-input="handleQuickSearchInput"
      :menu-props="{ closeOnContentClick: true }" :loading="loadingQuickSearch" :items="filteredQuickSearchItems"
      :label="$t('message.quick_search')" dense outlined rounded :filter="() => true">
      <template v-slot:item="{ item }">
        <template v-if="item.header">
          <v-list-item-header>{{ item.header }}</v-list-item-header>
        </template>
        <template v-else>
          <v-list-item @click="goToQuickSearchItem(item)" class="pa-2">
            <v-list-item-avatar size="30" v-if="item.type == 'member'" class="pr-0 mr-0">
              <ImageDisplay v-if="item.image" :src="item.image" />
              <img v-else :src="assets('default-profile-avatar.png')" />
            </v-list-item-avatar>
            <v-list-item-action v-if="item.type == 'visitor' || item.type == 'prospect'" class="pl-1">
              <v-icon color="gray">mdi-target-account</v-icon>
            </v-list-item-action>
            <v-list-item-action v-else class="pl-1">
              <v-icon color="gray" v-if="item.icon == 'creditcard'">mdi-cash</v-icon>
              <v-icon color="gray" v-else-if="item.icon == 'users'">mdi-account-group-outline</v-icon>
              <v-icon color="gray" v-else-if="item.icon == 'documents'">mdi-text-box-outline</v-icon>
              <v-icon color="gray" v-else-if="item.icon == 'shopping'">mdi-shopping-outline</v-icon>
              <v-icon color="gray" v-else>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content class="pa-2">
              <span class="ml-2" v-if="item.type != 'member'">{{
                item.text
                }}</span>
              <span v-else>{{ item.text }}</span>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-autocomplete>
    <div v-if="paymentsReady" v-allowed="'view_payment_alerts'" class="ml-1">
      <v-badge v-if="$store.state.notificationsCount > 0" overlap color="error"
        :content="$store.state.notificationsCount">
        <v-btn icon small @click="navigateTo({ name: 'notifications' })">
          <v-icon>mdi-bell-outline</v-icon>
        </v-btn>
      </v-badge>
      <v-btn v-else icon small @click="navigateTo({ name: 'notifications' })">
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn>
    </div>

    <v-toolbar-title class="ml-1">
      <UserMenu :darkTheme="darkTheme" :appVersion="appVersion" :stripeAccountId="stripeAccountId"
        @toggle-theme="$emit('toggle-theme', $event)" @toggle-admin-plus="$emit('toggle-admin-plus', $event)"
        @open-feedback="$emit('open-feedback', $event)" @open-tech-support="$emit('open-tech-support', $event)"
        @logout="$emit('logout', $event)" @reload-refresh="$emit('reload-refresh', $event)"
        @copy="$emit('copy', $event)" />
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
import UserMenu from "@/components/layout/UserMenu/index.vue";


export default {
  name: "NavbarLegacy",
  components: {
    UserMenu,
  },
  props: {
    minimizedDrawer: {
      type: Boolean,
      default: true,
    },
    quickSearchQuery: {
      type: String,
      default: null,
    },
    loadingQuickSearch: {
      type: Boolean,
      default: false,
    },
    filteredQuickSearchItems: {
      type: Array,
      default: () => [],
    },
    paymentsReady: {
      type: Boolean,
      default: false,
    },
    darkTheme: {
      type: Boolean,
      default: false,
    },
    appVersion: {
      type: String,
      default: null,
    },
    stripeAccountId: {
      type: String,
      default: null,
    },
  },
  methods: {
    assets(path) {
      return require(`@/assets/${path}`);
    },
    isSmallerDisplay() {
      return this.$root.isSmallerDisplay ? this.$root.isSmallerDisplay() : false;
    },
    handleQuickSearchInput(value) {
      this.$emit("update:quickSearchQuery", value);
    },
    goToQuickSearchItem(item) {
      this.$emit("go-to-quick-search-item", item);
    },
    navigateTo(route) {
      this.$emit("navigate", route);
    },
  },
};
</script>
